<script setup lang="ts">
    import {
        getLibraryListLink
    } from '@/shared/helpers/routing';

</script>

<template>
    <h1 class="title">
        <b-icon
            icon="file-document-multiple-outline" />
        Documentation
    </h1>
    <h2 class="subtitle">
        Documentation is a love letter that you write to your future self
    </h2>
    <hr>
    <slot />
    <div style="margin-top: 2em; color: var(--eq-text-secondary);">
        This is a readonly view of the documentation content in CommonLibrary.
        Any changes to the documentation are done in
        <router-link :to="getLibraryListLink(['Documentation'])">
            the regular library UI.
        </router-link>
    </div>
</template>
